import styled from "styled-components";
import { getBreakpoints } from "../../../assets/store/cssBreakpoints";
const { xs, sm, md, lg, xl, xxl } = getBreakpoints();

export const StyledContainer = styled.div`
    &&& {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 100%;
        color: black;
        background-color: ${({ bgColor }) => bgColor ?? "transparent"};
        font-family: ${({ defaultFontFamily }) =>
            defaultFontFamily ?? "inherit"};
        min-height: 5em;
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;
        padding: ${(props) => (props.mobile ? "1em" : "2em 5em")};
        box-sizing: border-box;
    }
`;

export const Title = styled.h3`
    &&& {
        color: black;
        text-align: center;
        font-size: 1.6em;
        font-weight: 500;
        padding-top: 0px;
        margin-top: 10px;
        margin-bottom: 20px; // 0px if there's a subtitle
    }
`;

export const SubTitle = styled.h3`
    &&& {
        color: black;
        text-align: center;
        font-size: 1em;
        font-weight: 600;
        padding-top: 0px;
        margin-top: 5px;
        margin-bottom: 20px;
    }
`;

export const BodyText = styled.p`
    &&& {
        color: black;
        font-size: 15px;
        text-align: center;
        margin: 0;

        & a {
            color: ${({ textColor }) => textColor ?? "black"};
            text-decoration: none;

            &:hover {
                color: ${({ textHoverColor }) => textHoverColor ?? "blue"};
            }
        }
    }
`;
